import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { fetch } from "../modules/utils"; // Fetches the customer's active Open Banking statuses (one per bank/institution,
// already deduped and priority-ordered by the Data API), plus - when the page was
// just reached via a GoCardless redirect (`ref`/`error` query params) - the one-time
// post-redirect message for that redirect. Shared by OpenBankingIndex,
// ExpensesBuilderIndex and OpenBankingTile so they never disagree on what's
// currently connected/in progress.
export const useOpenBankingRequisitions = () => {
    const location = useLocation();
    const [requisitions, setRequisitions] = useState([]);
    const [requisitionsError, setRequisitionsError] = useState(false);
    const [postRedirectContent, setPostRedirectContent] = useState(null);
    const [postRedirectError, setPostRedirectError] = useState(null);
    const [isLoading, setIsLoading] = useState(true); // Existing connections are unknown (not "none") on failure, so callers must not
    // treat this the same as a successful empty response.
    const fetchStatuses = useCallback(() => fetch('GET', '/gocardless/statuses', 'application/json').then(({ statuses }) => { setRequisitions(statuses || []); setRequisitionsError(false); }).catch(error => { console.error('Error fetching active requisitions:', error); setRequisitionsError(true); }), []);
    useEffect(() => {
        setIsLoading(true);
        const params = new URLSearchParams(location.search);
        const ref = params.get('ref');
        const error = params.get('error');
        const fetchRedirectStatus = () => { const query = new URLSearchParams(); if (ref)
            query.set('ref', ref); if (error)
            query.set('error', error); const queryString = query.toString(); return fetch('GET', `/open_banking/redirect_status${queryString ? `?${queryString}` : ''}`, 'application/json').then(response => { if (response.post_redirect_content)
            setPostRedirectContent(response.post_redirect_content); if (response.post_redirect_error)
            setPostRedirectError(response.post_redirect_error); }).catch(error => { console.error('Error fetching post-redirect status:', error); }); };
        const requests = [fetchStatuses()];
        if (ref && ref !== 'null')
            requests.push(fetchRedirectStatus());
        Promise.allSettled(requests).finally(() => setIsLoading(false)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return { requisitions, requisitionsError, postRedirectContent, postRedirectError, isLoading, refetchRequisitions: fetchStatuses };
};
